import { render, staticRenderFns } from "./BiosecurityIncidentForm.vue?vue&type=template&id=6945d230"
import script from "./BiosecurityIncidentForm.vue?vue&type=script&lang=js"
export * from "./BiosecurityIncidentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports